import { Avatar } from '@mela/design-system';

export function PullQuote() {
  return (
    <section className="py-24 bg-ink-900 text-white relative overflow-hidden text-center">
      <div
        className="absolute -top-[200px] -left-[200px] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(109,40,217,0.18),transparent_70%)] pointer-events-none"
        aria-hidden="true"
      />
      <div
        className="absolute -bottom-[200px] -right-[200px] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(255,107,26,0.10),transparent_70%)] pointer-events-none"
        aria-hidden="true"
      />

      <div className="max-w-[880px] mx-auto px-6 sm:px-8 relative">
        <div className="font-display text-[96px] text-saffron-500 leading-[0.5] mb-6 font-extrabold">
          “
        </div>

        {/* Red-team flag: this is a scenario from a pilot conversation, not a closed-loop testimonial.
            Marked "scenario" copy below until first real case study lands. */}
        <p className="font-display text-[28px] sm:text-[44px] leading-[1.2] -tracking-[0.025em] font-bold text-white mb-8">
          Captured 247 leads at Vibrant Gujarat. Mela followed up in{' '}
          <em className="not-italic text-saffron-500">Gujarati</em>. Closed 18 deals in 30 days —{' '}
          <em className="not-italic text-saffron-500">4× our previous best event</em>.
        </p>

        <div className="inline-flex items-center gap-4">
          <Avatar
            initials="SP"
            size="lg"
            className="from-saffron-400 to-saffron-600 bg-gradient-to-br text-white"
          />
          <div className="text-left">
            <div className="font-bold text-white text-[15px]">Sneha Patel</div>
            <div className="text-[13px] text-ink-400">Director, Patel Textiles · Surat</div>
            <div className="text-[10px] text-ink-500 font-mono uppercase tracking-wider mt-1">
              Pilot scenario · real case study coming Q3
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
